import { Routes } from '@angular/router';

import { authBootstrapGuard } from '@venecia/guards';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('@venecia/templates').then(m => m.ShellLayout),
        canActivate: [authBootstrapGuard],
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'login' },
            { path: 'login', loadComponent: () => import('@venecia/pages').then(m => m.Login) },
            { path: 'otp', loadComponent: () => import('@venecia/pages').then(m => m.Otp) },
            { path: 'recovery', loadComponent: () => import('@venecia/pages').then(m => m.Recovery) },
            { path: 'change-password', loadComponent: () => import('@venecia/pages').then(m => m.ChangePassword) },
            { path: 'verification', loadComponent: () => import('@venecia/pages').then(m => m.VerifyAccount) },
            { path: '**', redirectTo: 'login' },
        ]
    },

    { path: '**', redirectTo: '' },
];
